<template>
  <v-card height='100%'>
      <v-container fluid class="pa-5">
        <v-row>       
          <v-col cols="12" md="auto">
            <span id="portfolio"> Portfolio </span>
            <v-select
              label ="Constituents date"
              v-model="constituentsDate"
              :items="listDates"
              v-on:change="updatePortfolio()"
            ></v-select>
          </v-col>
                    
          <v-spacer></v-spacer>
          <v-col cols="12" md="auto">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Filter"
              single-line
              hide-details
              style="max-width: 250px;"
              class="float-right"
            ></v-text-field>
          </v-col>            
          <v-col cols="12">
            <v-skeleton-loader v-if="listLoad" type="table"></v-skeleton-loader>
            <v-overlay
              :absolute="absolute"
              :opacity="opacity"
              :value="overlay"
            >
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>            
            <v-data-table
              v-show="!listLoad"
              :headers="headers"
              :items="items"
              :search.sync="search"
              :mobile-breakpoint="0"
            >
              <template v-slot:item="row">
                <tr>
                  <td>
                    <v-btn
                      class="px-2 mr-2"
                      color="primary"
                      min-width="0"
                      icon
                      small
                      :to="'/stocks/analyze/' + row.item.ric"       
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">
                            mdi-magnify-plus-outline
                          </v-icon>                        
                        </template>
                        <span>Analyze</span>
                      </v-tooltip> 
                    </v-btn>
                  </td>                  
                  <td>{{ row.item.name }}</td>
                  <td>{{ row.item.ric }}</td>
                  <td>{{ row.item.ticker }}</td>
                  <td>{{ row.item.country }}</td>
                  <td>{{ row.item.sector }}</td>                                        
                  <td class="text-right">
                    <span class="px-4">
                      {{ row.item.days_to_trade }}
                    </span>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                       <v-icon dense small style="color: #e1e4ea; " v-on="on">mdi-alert-circle-outline </v-icon>
                    </template>
                    <span>Decile {{ row.item.decile }}/10 (higher decile means more potential demand)</span>
                  </v-tooltip>  
                  </td>                                               
                  <td class="text-right">
                    <span class="px-4">
                      {{ formatWeight(row.item.weight) }}
                    </span>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
</template>

<script>
  var numeral = require("numeral");

  export default {
    name: 'PortfolioAnalyzeComponentPortfolio',
    props: ['ptf'],
    data() {
      return {
        absolute: true,
        opacity: 0.46,
        overlay: false,         
        headers: [
          {
            sortable: false,
            text: '',
            align: 'left',
          },              
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          { text: 'RIC', value: 'ric' },          
          { text: 'Ticker', value: 'ticker' },
          { text: 'Country', value: 'country' },
          { text: 'Sector', value: 'sector' },                    
          { text: 'Days to Trade', align: 'right', value: 'days_to_trade' },                    
          //{ text: 'Weight', value: 'weight' },
          // { text: 'No of Shares', value: 'shares' },
        ],
        items: [
        ],
        wgt: 0,
        weight_type_already_defined: false,
        listLoad: true,
        errorbar: false,
        search: '',
        constituentsDate: "",
        listDates:[]        
      }
    },
    mounted () {
      this.getListFromApi()
    },    
    methods: {
      formatWeight(d){
        //numeral('0.[00]%')
        if (this.wgt==1) {
          //return this.$options.filters.numeral(d).format('0.[00]%');
          return numeral(d).format('0.[00]%');
        } else {
          //return this.$options.filters.numeral(d).format('0.0');
          return numeral(d).format('0.0');
        }
      },  
      updatePortfolio() {
        this.getListFromApi();
      },          
      async getListFromApi() {
        var self = this
        this.overlay=true
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.$http.get(process.env.VUE_APP_API_HOST + '/get-user-ptf-portfolio-at-date/' + self.ptf + '/' + this.constituentsDate,{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          self.items = response.data.constituents//Date 
          self.constituentsDate = response.data.constituentsDate
          self.listDates = response.data.listDates
          self.wgt = response.data.wgt_type//Date 
          if (!self.weight_type_already_defined) {
            if (self.wgt ==1){
              self.headers.push({ text: 'Weight', value: 'weight', align: 'right' })
            }
            else{
              self.headers.push({ text: 'Quantity', value: 'weight', align: 'right' })
            }
          }
          self.weight_type_already_defined=true
          self.listLoad = false
          self.overlay=false
        }).catch(function (/*error*/) {
          //console.log(error)
          self.listLoad = false
          self.overlay=false
          //self.errorbar = true
        })
      }
    },
  }
</script>

